var _filter, _filter2, _filter3, _filter4, _filter5, _filter6, _filter7, _filter8, _filter9, _filter0, _filter1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEngagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_252_2728)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_2728)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 0.985352,
    width: 64,
    height: 64,
    rx: 21.1764,
    fill: "#D0D5DD",
    style: {
      fill: "#D0D5DD",
      fill: "color(display-p3 0.8144 0.8349 0.8656)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.7405,
    cy: 54.241,
    r: 18.2556,
    fill: "#6CE9A6",
    style: {
      fill: "#6CE9A6",
      fill: "color(display-p3 0.4234 0.9138 0.6523)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_252_2728",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 35,
    width: 37,
    height: 38
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.7405,
    cy: 54.241,
    r: 18.2556,
    fill: "#6CE9A6",
    style: {
      fill: "#6CE9A6",
      fill: "color(display-p3 0.4234 0.9138 0.6523)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_252_2728)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_252_2728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.1239 54.241H14.1177L33.8946 81.6245L64.3206 72.4966L68.1239 54.241Z",
    fill: "#32D583",
    style: {
      fill: "#32D583",
      fill: "color(display-p3 0.1960 0.8353 0.5157)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 40.7404,
    cy: 54.2409,
    r: 13.6917,
    fill: "#12B76A",
    style: {
      fill: "#12B76A",
      fill: "color(display-p3 0.0709 0.7173 0.4157)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M39.6944 44.8601C39.6204 44.1959 40.0998 43.5901 40.7681 43.5918C42.7181 43.5969 44.6379 44.1376 46.3128 45.166C47.9878 46.1945 49.3385 47.662 50.2251 49.3988C50.529 49.994 50.2056 50.6956 49.5797 50.9301C48.9538 51.1645 48.2639 50.8413 47.9403 50.2565C47.2563 49.0204 46.2618 47.9749 45.0463 47.2286C43.8309 46.4823 42.4486 46.0684 41.0368 46.0175C40.3689 45.9934 39.7685 45.5244 39.6944 44.8601Z",
    fill: "#FFFCF5",
    style: {
      fill: "#FFFCF5",
      fill: "color(display-p3 1.0000 0.9893 0.9600)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_252_2728",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 40,
    width: 28,
    height: 28
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.7404,
    cy: 54.2409,
    r: 13.6917,
    fill: "#FEC84B",
    style: {
      fill: "#FEC84B",
      fill: "color(display-p3 0.9965 0.7856 0.2937)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_252_2728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5687 51.134L38.2651 58.7212C37.9982 59.1031 37.8647 59.294 37.6885 59.3879C37.5334 59.4705 37.3562 59.5019 37.1822 59.4776C36.9844 59.45 36.7935 59.3165 36.4117 59.0496L33.7723 57.2046C33.3904 56.9377 33.1995 56.8043 33.0017 56.7766C32.8277 56.7523 32.6505 56.7837 32.4955 56.8663C32.3192 56.9602 32.1857 57.1511 31.9188 57.533L28.6373 62.2275M43.5687 51.134L37.8348 52.1498M43.5687 51.134L44.5845 56.8679",
    stroke: "url(#paint0_linear_252_2728)",
    style: {},
    strokeWidth: 2.76135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_252_2728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.7699 58.1583L51.9953 57.9776L52.1361 57.2835L52.2453 57.9491L52.5305 58.0442L52.2453 58.2343L52.1361 58.8048L52.0551 58.2343L51.7699 58.1583Z",
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_252_2728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3469 54.4692L48.7977 54.1079L49.0794 52.7197L49.2977 54.0508L49.8682 54.241L49.2977 54.6213L49.0794 55.7623L48.9174 54.6213L48.3469 54.4692Z",
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M57.1197 3.63447C58.3722 2.22476 60.5746 2.22476 61.827 3.63447L66.5019 8.89619C66.8043 9.23655 67.1769 9.50727 67.5941 9.6897L74.0429 12.5098C75.7706 13.2654 76.4512 15.3599 75.4975 16.9867L71.938 23.0588C71.7077 23.4515 71.5654 23.8896 71.5208 24.3427L70.8315 31.3473C70.6468 33.224 68.8651 34.5185 67.0232 34.1142L60.1484 32.6052C59.7037 32.5076 59.2431 32.5076 58.7984 32.6052L51.9236 34.1142C50.0817 34.5185 48.3 33.224 48.1153 31.3473L47.426 24.3427C47.3814 23.8896 47.2391 23.4515 47.0088 23.0588L43.4492 16.9867C42.4956 15.3599 43.1761 13.2654 44.9039 12.5098L51.3527 9.6897C51.7698 9.50728 52.1425 9.23655 52.4449 8.89619L57.1197 3.63447Z",
    fill: "#D0D5DD",
    style: {
      fill: "#D0D5DD",
      fill: "color(display-p3 0.8144 0.8349 0.8656)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6845 3.16672L62.587 2.25195C60.8606 0.54882 58.0862 0.54882 56.3598 2.25195L50.9824 7.55695C50.8492 7.68833 50.697 7.79891 50.5309 7.88497L43.8239 11.3598C41.6706 12.4754 40.8133 15.1141 41.8996 17.2822L45.2832 24.0358C45.367 24.203 45.4251 24.382 45.4557 24.5665L46.6879 32.0191C47.0834 34.4117 49.328 36.0425 51.7258 35.6794L59.1944 34.5483C59.3793 34.5203 59.5675 34.5203 59.7524 34.5483L67.221 35.6794C69.6188 36.0425 71.8633 34.4117 72.2589 32.0191L73.4911 24.5665C73.5216 24.382 73.5798 24.203 73.6636 24.0358L77.0472 17.2822C78.1335 15.1141 77.2762 12.4754 75.1229 11.3598L68.4159 7.88497C68.2497 7.79891 68.0975 7.68833 67.9644 7.55695L62.587 2.25195L61.6845 3.16672Z",
    fill: "#98A2B3",
    stroke: "#F2F4F7",
    style: {
      fill: "#98A2B3",
      fill: "color(display-p3 0.5964 0.6352 0.7017)",
      fillOpacity: 1,
      stroke: "#F2F4F7",
      stroke: "color(display-p3 0.9498 0.9558 0.9679)",
      strokeOpacity: 1
    },
    strokeWidth: 2.57
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_252_2728",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 2,
    width: 35,
    height: 33
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.2999 3.05921C58.5164 1.89845 60.4303 1.89845 61.6469 3.0592L67.2053 8.36285C67.4085 8.55677 67.6368 8.72262 67.884 8.85598L74.6457 12.5034C76.1256 13.3017 76.717 15.1219 75.989 16.6376L72.6625 23.5629C72.5409 23.8161 72.4537 24.0844 72.4033 24.3607L71.0239 31.9186C70.722 33.5728 69.1736 34.6977 67.5071 34.4737L59.8929 33.4501C59.6145 33.4127 59.3323 33.4127 59.0539 33.4501L51.4397 34.4737C49.7732 34.6977 48.2248 33.5728 47.9229 31.9186L46.5435 24.3607C46.4931 24.0844 46.4059 23.8161 46.2842 23.5629L42.9578 16.6376C42.2298 15.1219 42.8212 13.3017 44.3011 12.5034L51.0628 8.85598C51.31 8.72262 51.5383 8.55677 51.7415 8.36285L57.2999 3.05921Z",
    fill: "#D0D5DD",
    style: {
      fill: "#D0D5DD",
      fill: "color(display-p3 0.8144 0.8349 0.8656)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_252_2728)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter4_f_252_2728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9871 21.2796L31.3736 21.2796L35.2764 42.3544L57.1317 64.2097L78.9871 42.3544L78.9871 21.2796Z",
    fill: "#98A2B3",
    style: {
      fill: "#98A2B3",
      fill: "color(display-p3 0.5964 0.6352 0.7017)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4712 15.0352C56.8834 15.0352 54.7803 17.1266 54.7847 19.7095C54.7847 22.2924 56.8834 24.3837 59.4712 24.3837C62.059 24.3837 64.1621 22.2924 64.1621 19.7095C64.1621 17.1266 62.0633 15.0352 59.4712 15.0352ZM59.4712 25.6299C58.7918 25.6342 58.0432 25.5739 57.1993 25.4186C55.529 25.1082 54.525 24.2371 52.4998 24.6338C48.0426 25.5092 44.2172 38.2729 49.674 38.4497C52.595 38.5445 54.3736 35.2458 56.5805 34.3791C57.1734 34.1462 58.3504 34.0341 59.4712 34.0298C60.5963 34.0341 61.7691 34.1462 62.3663 34.3791C64.5732 35.2458 66.3518 38.5445 69.2728 38.4497C74.7296 38.2729 70.9042 25.5092 66.447 24.6338C64.4218 24.2328 63.4135 25.1039 61.7474 25.4186C60.9036 25.5739 60.155 25.6342 59.4712 25.6299Z",
    fill: "url(#paint1_linear_252_2728)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_252_2728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.2302 15.9328L69.4615 15.7475L69.606 15.0352L69.7181 15.7182L70.0108 15.8158L69.7181 16.0109L69.606 16.5963L69.5229 16.0109L69.2302 15.9328Z",
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_252_2728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7178 12.1472L66.1803 11.7765L66.4694 10.3519L66.6935 11.7179L67.2789 11.913L66.6935 12.3033L66.4694 13.4741L66.3032 12.3033L65.7178 12.1472Z",
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter7_f_252_2728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2789 12.6936L54.7902 -0.575683L61.0345 -6.82007L88.3537 6.44925L84.451 19.7186L67.2789 12.6936Z",
    fill: "#98A2B3",
    style: {
      fill: "#98A2B3",
      fill: "color(display-p3 0.5964 0.6352 0.7017)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 22.485,
    cy: 19.7189,
    r: 17.3702,
    fill: "#FDB022",
    style: {
      fill: "#FDB022",
      fill: "color(display-p3 0.9913 0.6913 0.1342)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_252_2728",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 35,
    height: 36
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.485,
    cy: 19.7189,
    r: 17.3702,
    fill: "#FDB022",
    style: {
      fill: "#FDB022",
      fill: "color(display-p3 0.9913 0.6913 0.1342)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_252_2728)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_252_2728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5403 19.7189H-2.84668L15.9711 45.7743L44.9215 37.0892L48.5403 19.7189Z",
    fill: "#F79009",
    style: {
      fill: "#F79009",
      fill: "color(display-p3 0.9701 0.5644 0.0338)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 22.485,
    cy: 19.7188,
    r: 13.0277,
    fill: "#F79009",
    style: {
      fill: "#F79009",
      fill: "color(display-p3 0.9701 0.5644 0.0338)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M21.4897 10.793C21.4192 10.161 21.8754 9.58456 22.5113 9.5862C24.3668 9.591 26.1934 10.1055 27.7871 11.0841C29.3808 12.0627 30.666 13.459 31.5097 15.1115C31.7988 15.6779 31.4911 16.3455 30.8956 16.5685C30.3 16.7916 29.6436 16.484 29.3356 15.9276C28.6848 14.7515 27.7385 13.7567 26.582 13.0466C25.4255 12.3365 24.1103 11.9426 22.767 11.8942C22.1314 11.8713 21.5602 11.425 21.4897 10.793Z",
    fill: "#FFFCF5",
    style: {
      fill: "#FFFCF5",
      fill: "color(display-p3 1.0000 0.9893 0.9600)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_252_2728",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 6,
    width: 27,
    height: 27
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.485,
    cy: 19.7188,
    r: 13.0277,
    fill: "#FEC84B",
    style: {
      fill: "#FEC84B",
      fill: "color(display-p3 0.9965 0.7856 0.2937)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_252_2728)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4829 15.3763C20.0834 15.3763 18.1333 17.3155 18.1373 19.7105C18.1373 22.1055 20.0834 24.0447 22.4829 24.0447C24.8824 24.0447 26.8326 22.1055 26.8326 19.7105C26.8326 17.3155 24.8865 15.3763 22.4829 15.3763ZM22.4829 25.2002C21.853 25.2042 21.1588 25.1482 20.3763 25.0043C18.8275 24.7164 17.8966 23.9087 16.0187 24.2766C11.8858 25.0882 8.33867 36.9233 13.3985 37.0872C16.107 37.1752 17.7561 34.1165 19.8025 33.3128C20.3523 33.0969 21.4437 32.9929 22.4829 32.9889C23.5262 32.9929 24.6136 33.0969 25.1673 33.3128C27.2137 34.1165 28.8629 37.1752 31.5714 37.0872C36.6312 36.9233 33.0841 25.0882 28.9512 24.2766C27.0733 23.9047 26.1384 24.7124 24.5935 25.0043C23.8111 25.1482 23.1169 25.2042 22.4829 25.2002Z",
    fill: "url(#paint2_linear_252_2728)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_252_2728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6093 17.6561L15.8237 17.4842L15.9577 16.8238L16.0616 17.4571L16.333 17.5476L16.0616 17.7285L15.9577 18.2713L15.8807 17.7285L15.6093 17.6561Z",
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_252_2728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3522 14.1459L12.7811 13.8022L13.0491 12.4813L13.2569 13.7478L13.7997 13.9288L13.2569 14.2907L13.0491 15.3763L12.895 14.2907L12.3522 14.1459Z",
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  }))))), /*#__PURE__*/React.createElement("rect", {
    x: 9.49357,
    y: 1.97892,
    width: 62.0129,
    height: 62.0129,
    rx: 20.1829,
    stroke: "url(#paint3_linear_252_2728)",
    style: {},
    strokeWidth: 1.98714
  })), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_252_2728",
    x: 0.75596,
    y: 0.985352,
    width: 79.4881,
    height: 79.4881,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.54881,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_252_2728"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.09762
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.54881
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_252_2728"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.54881,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_252_2728"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.74404
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.64642
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_252_2728",
    result: "effect2_dropShadow_252_2728"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_252_2728",
    result: "shape"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_252_2728",
    x: 9.51542,
    y: 49.6388,
    width: 63.2107,
    height: 36.5879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.30113,
    result: "effect1_foregroundBlur_252_2728"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_252_2728",
    x: 51.6165,
    y: 57.1301,
    width: 1.06744,
    height: 1.82812,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0767043,
    result: "effect1_foregroundBlur_252_2728"
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_252_2728",
    x: 48.1935,
    y: 52.5663,
    width: 1.82806,
    height: 3.34942,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0767043,
    result: "effect1_foregroundBlur_252_2728"
  }))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_252_2728",
    x: 25.0768,
    y: 14.9827,
    width: 60.2071,
    height: 55.5239,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.14843,
    result: "effect1_foregroundBlur_252_2728"
  }))), _filter6 || (_filter6 = /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_252_2728",
    x: 69.0728,
    y: 14.8778,
    width: 1.09536,
    height: 1.87594,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0787107,
    result: "effect1_foregroundBlur_252_2728"
  }))), _filter7 || (_filter7 = /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_252_2728",
    x: 65.5604,
    y: 10.1945,
    width: 1.876,
    height: 3.43704,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0787107,
    result: "effect1_foregroundBlur_252_2728"
  }))), _filter8 || (_filter8 = /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_252_2728",
    x: 48.4933,
    y: -13.1169,
    width: 46.1573,
    height: 39.1324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.14843,
    result: "effect1_foregroundBlur_252_2728"
  }))), _filter9 || (_filter9 = /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_252_2728",
    x: -5.76605,
    y: 16.7996,
    width: 57.2257,
    height: 31.8941,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.45968,
    result: "effect1_foregroundBlur_252_2728"
  }))), _filter0 || (_filter0 = /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_252_2728",
    x: 15.4633,
    y: 16.6778,
    width: 1.01569,
    height: 1.73945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0729842,
    result: "effect1_foregroundBlur_252_2728"
  }))), _filter1 || (_filter1 = /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_252_2728",
    x: 12.2062,
    y: 12.3353,
    width: 1.73945,
    height: 3.18696,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0729842,
    result: "effect1_foregroundBlur_252_2728"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_252_2728",
    x1: 42.9882,
    y1: 47.8575,
    x2: 30.5452,
    y2: 61.5516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    style: {
      stopColor: "white",
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.66,
    style: {
      stopColor: "white",
      stopColor: "white",
      stopOpacity: 0.66
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_252_2728",
    x1: 59.4734,
    y1: 15.0352,
    x2: 59.4734,
    y2: 38.4517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    style: {
      stopColor: "white",
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455074,
    stopColor: "white",
    stopOpacity: 0.561695,
    style: {
      stopColor: "white",
      stopColor: "white",
      stopOpacity: 0.561695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    style: {
      stopColor: "white",
      stopColor: "white",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_252_2728",
    x1: 22.4849,
    y1: 15.3763,
    x2: 22.4849,
    y2: 37.0891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    style: {
      stopColor: "white",
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455074,
    stopColor: "white",
    stopOpacity: 0.561695,
    style: {
      stopColor: "white",
      stopColor: "white",
      stopOpacity: 0.561695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    style: {
      stopColor: "white",
      stopColor: "white",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_252_2728",
    x1: 61.6936,
    y1: 68.5456,
    x2: 40.5,
    y2: 5.48048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    style: {
      stopColor: "white",
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_2728"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 0.985352,
    width: 64,
    height: 64,
    rx: 21.1764,
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEngagement);
export default __webpack_public_path__ + "static/media/icon-engagement.59a9ebb310c4f803f36329e249a3f1ac5d46317197fb24179d6da783302a0fad.svg";
export { ForwardRef as ReactComponent };